import { render, staticRenderFns } from "./TrimText.vue?vue&type=template&id=cbe8257c"
import script from "./TrimText.vue?vue&type=script&lang=js"
export * from "./TrimText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports